import React from 'react';
import { HighlightSC } from './common.styles';

export const Highlight = ({ children }) => {
  return <HighlightSC data-testid="highlight">{children}</HighlightSC>;
};
